import { Selector } from './types';

type ComposeProps = <S, P1, P2, R>(selector2: Selector<S, P2, R>, selector1: Selector<S, P1, P2>) => Selector<S, P1, R>;

const composeProps: ComposeProps = (selector2, selector1) => (state, props) => {
    const composedProps = selector1(state, props);
    return selector2(state, composedProps);
};

export default composeProps;
